import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Paper,
  Table,
  TableBody,
} from '@material-ui/core';

import i18n from '../../i18n';

import EcommTableHeader from './EcommTableHeader';
import EcommTableFooter from './EcommTableFooter';
import EcommDataDateAndNameRow from './EcommDataDateAndNameRow';
import EcommDataSpecialProjectRow from './EcommDataSpecialProjectRow';
import EcommDataProductTierRow from './EcommDataProductTierRow';
import EcommDataNumberRow from './EcommDataNumberRow';
import EcommDataReadOnlyRow from './EcommDataReadOnlyRow';

class EcommDataCopyTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      copyData: {
        ...props.copyData
      }
    };
  }

  handleChange = (event, key) => {
    event.persist();
    const { name, value } = event.target;
    const keyValues = { [name]: value };
    const { saveOne } = this.props;
    this.setState(prevState => ({
      copyData: {
        ...prevState.copyData,
        [key]: {
          ...prevState.copyData[key],
          [name]: value
        }
      }
    }));
    if (value || value === 0) {
      const { copyData } = this.state;
      saveOne({
        date: copyData[key].date,
        locationType: 'copy',
        locationId: copyData[key].locationId,
        keyValues,
        updatedAt: new Date().getTime() / 1000
      });
    }
  };

  handleSpecialProjectChange = (event, key) => {
    event.persist();
    const { name, value } = event.target;
    const { saveOne } = this.props;
    // value === -1 is 'None'
    const isSpecialProject = value !== -1;
    const projectName = isSpecialProject ? value : null;
    const keyValues = { [name]: projectName, isSpecialProject };
    this.setState(prevState => ({
      copyData: {
        ...prevState.copyData,
        [key]: {
          ...prevState.copyData[key],
          [name]: projectName,
          isSpecialProject,
        }
      }
    }),
    () => {
      const { copyData } = this.state;
      saveOne({
        date: copyData[key].date,
        locationType: 'copy',
        locationId: copyData[key].locationId,
        keyValues,
        updatedAt: new Date().getTime() / 1000
      });
    });
  };

  getTabIndex = (column)=> {
    const { startTabIndex } = this.props;
    return startTabIndex + column
  }

  render() {
    const { copyData } = this.state;
    const {
      handleDatePickerChange,
      date,
      fetchPrevious,
      fetchNext,
      getNow,
      prepItemCount,
      specialProjectOptions,
      canEdit
    } = this.props;
    return (
      <Paper className="ecommForm">
        <Table>
          <EcommTableHeader
            headerKey="CopyTitle"
            tableTitle={i18n.t('location:copyTableTitle')}
          />
          <TableBody>
            <EcommDataDateAndNameRow
              date={date}
              fetchNext={fetchNext}
              fetchPrevious={fetchPrevious}
              handleDatePickerChange={handleDatePickerChange}
              locationNames={Object.keys(copyData).map(element =>
                  copyData[element].copyName)}
            />
            <EcommDataReadOnlyRow
              title={i18n.t('location:items').toUpperCase()}
              valueToDisplay={prepItemCount}
            />
            <EcommDataNumberRow
              getTabIndex={this.getTabIndex}
              canEdit={canEdit}
              handleChange={this.handleChange}
              locationData={copyData}
              rowTitle={i18n.t('location:additionalItems').toUpperCase()}
              valueKey="additionalItems"
            />
            <EcommDataSpecialProjectRow
              getTabIndex={this.getTabIndex}
              canEdit={canEdit}
              locationData={copyData}
              specialProjectOptions={specialProjectOptions}
              handleSpecialProjectChange={this.handleSpecialProjectChange}
            />
            <EcommDataProductTierRow
              getTabIndex={this.getTabIndex}
              canEdit={canEdit}
              locationData={copyData}
              handleChange={this.handleChange}
            />
          </TableBody>
          <EcommTableFooter getNow={getNow} />
        </Table>
      </Paper>
    );
  }
}

EcommDataCopyTable.propTypes = {
  copyData: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.string])
  ).isRequired,
  specialProjectOptions: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]).isRequired,
  prepItemCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  handleDatePickerChange: PropTypes.func.isRequired,
  fetchPrevious: PropTypes.func.isRequired,
  fetchNext: PropTypes.func.isRequired,
  saveOne: PropTypes.func.isRequired,
  startTabIndex: PropTypes.number,
  getNow: PropTypes.func.isRequired,
  canEdit: PropTypes.bool.isRequired,
  date: PropTypes.instanceOf(Date).isRequired,
};

EcommDataCopyTable.defaultProps = {
  startTabIndex: 500
};

export default EcommDataCopyTable;
